import { IOption } from '@skf/bt-wind-rail-commonlibrary/dist/components/form/types';

const assetTypeAcronymOptions: IOption[] = [
  { label: 'GEARBOX', value: 'GB', labelToShow: 'GEARBOX' },
  { label: 'GENERATOR', value: 'GE', labelToShow: 'GENERATOR' },
  {
    label: 'MAINSHAFT BEARING',
    value: 'MB',
    labelToShow: 'MAINSHAFT BEARING',
  },
  { label: 'YAW', value: 'YA', labelToShow: 'YAW' },
  { label: 'Pitch/Blade', value: 'BP', labelToShow: 'Pitch/Blade' },
];

export { assetTypeAcronymOptions };
